import React from 'react'

export default function Logo({ alwaysShowText = false }) {

    return (
        <>
            <div className='logo' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <img src='/assets/images/logo.png' alt='logo' />

                
            </div>
        </>
    )
}
